import React from "react";
import { Container } from "./styled";

const Contact = () => {
  return (
    <Container>
      <h1>Contacto</h1>
      <p>
        Si tienes algún problema, puedes contactar con nosotros a través de{" "}
        <a
          href="mailto:mmraverageman@gmail.com?subject=Deportactico Contact page"
          target="_blank"
          rel="noreferrer"
        >
          mmraverageman@gmail.com
        </a>
        .
      </p>
      <p className="sub-text">
        Estaremos respondiendo lo más rápido posible. Siempre estamos abiertos a
        responder tus consultas y ayudarte a solucionar tus problemas.
      </p>
    </Container>
  );
};

export default Contact;
